import { OrderedMap, Map, fromJS } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    marketsettings: Map(),
    isFetching: false,
    fetchError: null,
    isAllFetched: false
  });

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();
    case constants.FETCH_MARKET_SETTINGS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_MARKET_SETTINGS_DONE:
      return state
        .set('marketsettings', fromJS(payload))
        .set('fetchError', null)
        .set('isFetching', false)
        .set('isAllFetched', true);
    case constants.FETCH_MARKET_SETTINGS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.ONCHANGE_MARKET_SETTINGS_DATA:
      return state.set('marketsettings', fromJS(payload));

    case constants.SAVE_MARKET_SETTINGS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.SAVE_MARKET_SETTINGS_DONE:
      return (
        state
          // .set('feedback', highlightFeed(state, payload)) // write when integrate API
          // .set('isHighlightFeedback', fromJS(payload))
          .set('fetchError', null)
          .set('isFetching', false)
          .set('isAllFetched', true)
      );
    case constants.SAVE_MARKET_SETTINGS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    default:
      return state;
  }
}
